import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import SmiLogo from "../../../../src/collections/blog/2019/2019-05-21-a-standard-interface-for-service-meshes/smi-logo.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  SmiLogo,
  React
};